import {lazy} from 'react';

export const FundModuleLazy = lazy(() => import(/* webpackChunkName: "fundModule" */ '.'));
